import {apiInstance} from '../api_Instance';
import {queryOptions} from '@tanstack/react-query';

export const productApi = {
  getProductById: (productId) => {
    return queryOptions({
      queryKey: ['productByidList', productId],
      queryFn: (meta) =>
        apiInstance.get(`/products/${productId}`, {
          signal: meta.signal,
        }),

      select: (data) => {
        return data.data;
      },
    });
  },
  getRelatedProducts: (engineId) => {
    return queryOptions({
      queryKey: ['RelatedProducts', engineId],
      queryFn: (meta) =>
        apiInstance.get(
          `/products/`,
          {params: {product_engines__engine_id: engineId}},
          {
            signal: meta.signal,
          }
        ),

      select: (data) => {
        return data.data.results;
      },
    });
  },
};
